export default "__VITE_ASSET__DnJzPxfq__"